import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './TextLink.themes';
type Props = DynamicLinkProps & {
  className?: string;
  color?: Colors;
  iconName?: IconName;
  label?: string;
  theme?: ThemeKey<typeof themes>;
};
export const TextLink = ({
  className,
  color,
  iconName,
  label,
  theme = 'default',
  url,
  ...rest
}: Props) => {
  if (!label) {
    return null;
  }

  const { thIconWidth, thRoot } = themes[theme]({
    color,
  }) as DefaultThemeStyles<typeof themes>;
  const TagName = url ? DynamicLink : 'button';
  return (
    <TagName
      {...rest}
      className={classnames(thRoot, className)}
      {...(url
        ? {
            url,
          }
        : {
            type: 'button',
          })}
    >
      {label}
      {!!iconName && <Icon hasRtl name={iconName} width={thIconWidth} />}
    </TagName>
  );
};
